import React from "react";
import Typography from "@material-ui/core/Typography";
import {historialResources} from "../endpoints";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import SnackbarAlert from "../components/SnackbarAlert";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";

class Historial extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            cargando:true,
            datos:[],
            openSnack: false,
            severity: null,
            message: null,
        }
    }

    obtenerHistorial = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        historialResources.getHistorial().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,datos:result.historial})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true,cargando:false, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }
    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            this.obtenerHistorial()
        }
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return(
                <div>
                    <Typography variant="h4" gutterBottom>
                        Historial
                    </Typography>
                    <MaterialTable
                        localization={{
                            toolbar: {
                                searchPlaceholder: 'Buscar'
                            },
                            header: {
                                actions: 'Acciones'
                            },
                            body:{
                                emptyDataSourceMessage: 'No hay datos para mostrar'
                            }
                        }}
                        isLoading={this.state.cargando}
                        options={{
                            pageSize: 50,
                            pageSizeOptions: [10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            rowStyle: rowData => ({
                                backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                            }),
                            searchFieldStyle: {
                                width: "auto",
                            },
                            padding: "dense"
                        }}
                        icons={tableicons}
                        title={""}
                        data={this.state.datos}
                        columns={[
                            { title: 'Fecha y hora', field: 'timestamp',
                                render: rowData => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString(),
                                customFilterAndSearch: ((term, rowData) => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString().indexOf(term) !== -1),
                                cellStyle: {
                                    width: 250,
                                    maxWidth: 250,
                                },
                                headerStyle: {
                                    width: 250,
                                    maxWidth: 250
                                }},
                            { title: 'Acción', field: 'texto',
                                cellStyle: {
                                    width: 950,
                                    maxWidth: 950,
                                },
                                headerStyle: {
                                    width: 950,
                                    maxWidth: 950
                                }},
                        ]}

                        onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    />
                    {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                </div>
            )
        }
    }
}

export default Historial;